import React, { useEffect, useState } from 'react';
import '../Static/dashboard.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, FormControl, InputLabel, Select, MenuItem, Grid } from '@mui/material';


const UserDashboard = () => {

    const userdata = JSON.parse(sessionStorage.getItem('user'));
    // console.log(userdata?.subuser_info)

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    return (
        <>
            <div style={{ background: 'white', padding: '10px', display: 'flex', textAlign: 'center', justifyContent: 'center', marginTop: '100px' }}>
                {/* <table style={{ marginTop: '6%', width: '80%' }}>
                    <thead>
                        <th>Sr. No.</th>
                        <th>School Name</th>
                        <th>Code</th>
                        <th>Pages Assign</th>
                    </thead>
                    <tbody>
                        {userdata?.subuser_info?.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.schlNm}</td>
                                <td>{item.schlcd}</td>

                            </tr>
                        ))}
                    </tbody>
                </table> */}


                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle, width: '60%' }}>
                    <Table>
                        <TableHead>
                            <TableRow className='tbl-row'>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>School</TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Code</TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Page Assign</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {userdata?.subuser_info?.map((form, index) => (
                                <TableRow key={index}>

                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.schlNm}</TableCell>
                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.schlcd}</TableCell>
                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                        {/* {form.pageNmList.join(', ')} */}

                                        {form.pages_info.map((name, idx) => (
                                            <span key={idx}>
                                                {name.pages}
                                                {idx !== form.pages_info.length - 1 && <br />}
                                            </span>
                                        ))}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>


        </>
    );
}

export default UserDashboard;

